import type { IExaminationService } from '../../../../domain/precon-supporter/services';
import type { CourseId } from '../../../../domain/precon-supporter/value-objects';
import type {
  ExaminationResponse,
  GradingRequest,
  GradingResponse,
} from '../../../../domain/precon-supporter/types/examination';
import { PreconSupporterApiClient } from '../../api/precon-supporter-api-client';

/**
 * API経由で試験データを取得・送信するサービス
 */
export class ExaminationService implements IExaminationService {
  constructor(private apiClient: PreconSupporterApiClient) {}

  /**
   * 指定されたコースの試験データを取得
   * @param params - 取得パラメータ
   * @returns 試験データ
   */
  async fetchExaminationData(params: {
    courseId: CourseId;
    examinationId: number;
  }): Promise<ExaminationResponse> {
    try {
      const response = await this.apiClient.fetchExamination({
        courseId: params.courseId.getValue(),
        examinationId: params.examinationId,
      });

      return response;
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : '未知のエラーが発生しました';

      throw new Error(`試験データの取得に失敗しました: ${errorMessage}`);
    }
  }

  /**
   * 試験結果を採点サーバーに送信
   * @param request - 採点リクエスト
   * @returns 採点結果
   */
  async submitForGrading(request: GradingRequest): Promise<GradingResponse> {
    try {
      const response = await this.apiClient.submitGrading(request);
      return response;
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : '未知のエラーが発生しました';

      throw new Error(`採点に失敗しました: ${errorMessage}`);
    }
  }
}
